<template>
  <div class="event">
    <event-invite-link v-if="event || !(!event && finishedLoading)" :event-id="id"></event-invite-link>

    <section v-if="!finishedLoading" class="hero is-medium c-background--image">
      <div class="hero-body">
        <div class="container has-text-centered">
          <b-loading active></b-loading>

          <h1 class="title is-2 c-heading__title">
            {{ $t('loading') }}
          </h1>
        </div>
      </div>
    </section>

    <!--<pre>{{ event }}</pre>-->

    <section v-if="event" class="hero is-warning c-background--image">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-2 is-spaced c-heading__title">
            {{ event.name }}
          </h1>
          <h2 class="subtitle is-6 c-heading__subtitle">
            {{ $t('by') }} {{ event.initiator.name }} · {{ $d(new Date(event.createdAt), 'long', localeForDate) }}
            <br><br>
            <button
              v-if="isInitiator"
              class="button is-small is-light"
              @click="showEditEventModal = true"
              :disabled="event.id === demoEventId"
            >
              <span class="icon is-small"><i class="fa fa-pencil"></i></span>
              <span>{{ $t('edit') }}</span>
            </button>
          </h2>

          <div class="modal" :class="{ 'is-active': showEditEventModal }">
            <div class="modal-background" @click="showEditEventModal = false"></div>
            <event-edit-form :event="event" :on-close="() => showEditEventModal = false"></event-edit-form>
          </div>

          <div class="box">
            <div class="columns">
              <div class="column">
                <div class="level">
                  <div class="level-item has-text-centered">
                    <div>
                      <p class="title">{{ event.participants.length }}</p>
                      <p class="heading">Participants</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns is-multiline">
              <div v-if="predefinedItemsList.items.length === 0 && isInitiator" class="column is-12">
                <a class="button is-info is-rounded" @click="isOpen = !isOpen">
                  <span class="icon is-small"><i class="fa fa-plus"></i></span>
                  <span>{{ $t('addPredefinedItems') }}</span>
                </a>
              </div>

              <div class="column is-12" v-if="predefinedItemsList.items.length > 0 || isOpen">
                <user-box :user="predefinedItemsList" :event="event"></user-box>
              </div>

              <div class="column is-12">
                <user-form :event-id="event.id"></user-form>
              </div>

              <div
                v-for="participant in event.participants"
                v-if="participant.name.toLowerCase().includes(searchFilter.toLowerCase())"
                class="column is-12 is-6-fullhd"
              >
                <user-box :user="participant" :event="event"></user-box>
              </div>

              <div class="column is-12">
                <event-filters></event-filters>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <event-missing v-if="!event && finishedLoading"></event-missing>
  </div>
</template>

<script>
  import NProgress from 'nprogress'
  import UserBox from './UserBox'
  import UserForm from './UserForm'
  import EventEditForm from '@/components/EventEditForm'
  import { getEventById } from '@/shared/queries'
  import EventFilters from '@/components/EventFilters'
  import { mapState } from 'vuex'
  import EventInviteLink from '@/components/EventInviteLink'
  import EventMissing from './EventMissing.vue'
  import i18n from '@/i18n'

  export default {
    name: 'event',
    props: ['id'],
    components: {
      EventMissing,
      EventInviteLink,
      EventFilters,
      UserBox,
      UserForm,
      EventEditForm
    },
    mounted () {
      if (this.$route.query.admin) {
        localStorage.setItem('userId', this.$route.query.admin)
      }
    },
    data () {
      return {
        event: null,
        demoEventId: process.env.DEMO_EVENT_ID,
        isLoading: false,
        finishedLoading: false,
        showEditEventModal: false,
        isOpen: false,
        predefinedItemsList: {
          name: this.$t('itemsToBring'),
          items: []
        }
      }
    },
    computed: {
      ...mapState({
        searchFilter: state => state.filters.search
      }),
      isInitiator () {
        return localStorage.getItem('userId') && localStorage.getItem('userId') === this.event.initiator.id
      },
      localeForDate () {
        return i18n.locale.replace('_', '-')
      }
    },
    watch: {
      isLoading (newValue) {
        newValue ? NProgress.start() : NProgress.done()
      }
    },
    apollo: {
      event: {
        query: getEventById,
        variables () {
          return {
            id: this.id,
            userFilter: null
          }
        },
        update (data) {
          this.finishedLoading = true
          console.log('Event', data.Event)
          this.predefinedItemsList.items = data.Event.items
          return data.Event
        },
        loadingKey: 'isLoading'
      }
    }
  }
</script>

<style scoped>
  .c-heading__subtitle {
    margin-top: -0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Event.vue